import { render, staticRenderFns } from "./WaitQRPage.vue?vue&type=template&id=09b4c9b6&scoped=true"
import script from "./WaitQRPage.vue?vue&type=script&lang=js"
export * from "./WaitQRPage.vue?vue&type=script&lang=js"
import style0 from "./WaitQRPage.vue?vue&type=style&index=0&id=09b4c9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4c9b6",
  null
  
)

export default component.exports